import AppSettingController from "../../../Main/controller/AppSettingController";
import {useTranslation} from "react-i18next";

export default function ChangeTheme() {
    const {t} = useTranslation();
    const setting = AppSettingController.getSetting();

    return (
        <div className={"theme-colors"}>
            <p>{t("setting.customizingTheme")}</p>
            <div className={"colors-selector"}>
                {setting.colorArray.map((color: number) => (
                    <div key={color}
                         className={`theme-${color} ${setting.color === color ? 'selected' : ''}`}
                         onClick={() => AppSettingController.changeThemeColor(color)}
                         data-theme={setting.themeMode}>
                        <button className={`theme-${color}  ${setting.themeMode}`}/>
                    </div>
                ))}
            </div>
        </div>
    )
}